import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Grid,
  InputAdornment,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CustomExpandMore from "../../../common/CustomExpandMore";
import { useStyles } from "./styles";
import Pen from "../../../assets/images/CourseManagement/pen.svg";
import Close from "../../../assets/images/CourseManagement/close.svg";
import { useNavigate } from "react-router-dom";

const row = [
  {
    select: true,
    studentId: "***********",
    studentName: "Student Name",
    department: "Mehanical",
    batch: "2001-2004",
    leaveStartDate: "22-02-2001",
    leaveEndDate: "22-04-2001",
    Approve: "Approve",
    Reject: "Reject",
  },
  {
    select: true,
    studentId: "***********",
    studentName: "Student Name",
    department: "Mehanical",
    batch: "2001-2004",
    leaveStartDate: "22-02-2001",
    leaveEndDate: "22-04-2001",
    Approve: "Approve",
    Reject: "Reject",
  },
  {
    select: true,
    studentId: "***********",
    studentName: "Student Name",
    department: "Mehanical",
    batch: "2001-2004",
    leaveStartDate: "22-02-2001",
    leaveEndDate: "22-04-2001",
    Approve: "Approve",
    Reject: "Reject",
  },
];

const columns = [
  {
    id: "select",
    label: "Select",
    align: "center",
    sortby: true,
  },
  {
    id: "studentId",
    sortby: true,
    label: "Student Id",
    align: "center",
  },
  {
    id: "studentName",
    sortby: true,
    label: "Student Name",
    align: "center",
  },
  {
    id: "department",
    label: "Department",
    align: "center",
    sortby: true,
  },
  {
    id: "batch",
    label: "Batch",
    align: "center",
    sortby: true,
  },
  {
    id: "leaveStartDate",
    label: "Leave Start Date",
    align: "center",
    sortby: true,
  },
  {
    id: "leaveEndDate",
    label: "Leave End Date",
    align: "center",
    sortby: true,
  },
  {
    id: "approve",
    label: "Approve",
    align: "center",
  },
  {
    id: "reject",
    label: "Reject",
    align: "center",
  },
];

const LeaveApproval = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [addPage, setAddPage] = useState(true);

  return (
    <Grid container className={classes.leave}>
      <Grid item lg={10} sm={12}>
        <Stack sx={{ my: 4 }}>
          <Box sx={{ width: "100%" }}>
            <Paper
              sx={{
                width: "100%",
                p: 4,
                borderRadius: "20px",
                filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                boxShadow: "none",
              }}
            >
              {/* <Stack
                sx={{ flexDirection: "row", justifyContent: "flex-end", py: 2 }}
                className={classes.add_new_staff_container}
              >
                <Button
                  type="submit"
                  sx={{ px: 1, py: 1, borderRadius: "50px" }}
                  className={classes.add_new_staff}
                //   onClick={}
                >
                  Add new Student
                </Button>
              </Stack> */}

              <TableContainer>
                <Table
                  aria-label="sticky table"
                  className={classes.root}
                  style={{ padding: 0 }}
                >
                  <TableHead>
                    <TableRow classes={{ root: classes.thead }}>
                      {columns.map((column) => (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          style={{
                            minWidth: column.minWidth,
                            paddingLeft: column.paddingLeft,
                          }}
                          classes={{ root: classes.columnData }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody classes={{ root: classes.tBody }}>
                    {row.map((_el, index) => (
                      <TableRow role="checkbox" tabIndex={-1} key={index}>
                        {columns.map((column) => {
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {column.id === "select" ? (
                                <Stack sx={{ alignItems: "center" }}>
                                  <Checkbox defaultChecked />
                                </Stack>
                              ) : column.id === "studentId" ? (
                                _el.studentId
                              ) : column.id === "studentName" ? (
                                _el.studentName
                              ) : column.id === "department" ? (
                                _el.department
                              ) : column.id === "batch" ? (
                                _el.batch
                              ) : column.id === "leaveStartDate" ? (
                                _el.leaveStartDate
                              ) : column.id === "leaveEndDate" ? (
                                _el.leaveEndDate
                              ) : column.id === "approve" ? (
                                <Stack
                                  sx={{
                                    alignItems: "center",
                                    cursor: "pointer",
                                    color: "green",
                                  }}
                                  onClick={() => alert()}
                                >
                                  {/* <img src={Pen} alt="pen" /> */}
                                  <p>Approve</p>
                                </Stack>
                              ) : (
                                <Stack
                                  sx={{
                                    alignItems: "center",
                                    cursor: "pointer",
                                    color: "red",
                                  }}
                                  onClick={() => alert("delete")}
                                >
                                  <p>Reject</p>
                                  {/* <img src={Close} alt="close" /> */}
                                </Stack>
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Box>
        </Stack>
      </Grid>
      <Grid item lg={4} sm={12}></Grid>
    </Grid>
  );
};

export default LeaveApproval;
